import type { GenericFieldConfig } from '@neo/blocks/forms/types'
import { z } from 'zod'
import { v2validations } from '../config/validation.config'
import type { BusinessHourNodeData, SidebarComponentProps } from '../types'
import { AddBusinessHours } from './business-hours/add-business-hours'
import { GenericSidebarComponent } from './sidebar.base'

type FormValues = BusinessHourNodeData['config']

const fields = (nodeVars: string[]): GenericFieldConfig<FormValues> => {
  const validations = v2validations({ nodeVars }).business_hour
  return [
    {
      name: 'name',
      label: 'Name',
      zodValidation: validations.shape.name,
      componentType: 'input',
      inputProps: {
        type: 'text',
      },
    },
    {
      name: 'business_hrs',
      type: 'custom',
      zodValidation: z.array(z.any()).min(1, 'At least one business hour is required'),
      component: ({ form }) => (
        <div className="w-full col-span-2">
          <div>
            <p className="text-h4-500 text-foreground">Add & prioritize business hours</p>
            <p className="text-s-400 text-secondary">
              Order of priority defined below will be used in routing decisions when there are
              overlapping business hours.
            </p>
          </div>
          <AddBusinessHours form={form} />
        </div>
      ),
    },
  ]
}

// NODE_GEN: Update this code, do not commit directly
// Remove this comment after updating the code

export const BusinessHourSidebarComponent = (
  props: SidebarComponentProps<BusinessHourNodeData>,
) => {
  const { nodeVars } = props
  const formFields = fields(nodeVars)

  return <GenericSidebarComponent fields={formFields} {...props} />
}
